import { Card, Divider, Radio, Row, Typography } from "antd";
import { ConfigureCredits } from "components/Panel/Admin/ConfigureCredits";
import { useState } from "react";
import { AdminConfigureConstants } from "../ConfigureConstants";

export const AdminConfigurations = () => {
  const [tabIndex, setTabIndex] = useState<"configure-credits" | "configure-constants">(
    "configure-credits"
  );

  return (
    <div>
      <Row>
        <Typography
          style={{
            fontWeight: 500,
            fontSize: "30px",
            lineHeight: "38px"
          }}>
          Configuration
        </Typography>
      </Row>
      <Row>
        <Radio.Group
          style={{ marginBottom: 16, marginTop: 16, display: "flex" }}
          defaultValue={tabIndex}
          value={tabIndex}
          onChange={(e) => {
            setTabIndex(e.target.value);
          }}>
          <Radio.Button
            style={{
              color: "#CECFD2",
              fontSize: "14px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            value={"configure-credits"}>
            Configure credits
          </Radio.Button>
          <Radio.Button
            style={{
              color: "#CECFD2",
              fontSize: "14px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            value={"configure-constants"}>
            Configure constants
          </Radio.Button>
        </Radio.Group>
      </Row>
      <Row>
        <Divider style={{ backgroundColor: "#404040", padding: 0, margin: 0 }} />
      </Row>
      <Row>
        <Card
          style={{
            backgroundColor: "#202440",
            borderRadius: "10px",
            width: "100%",
            borderColor: "#202440",
            marginTop: "18px"
          }}>
          {tabIndex === "configure-credits" ? <ConfigureCredits /> : <AdminConfigureConstants />}
        </Card>
      </Row>
    </div>
  );
};
